import { useEffect } from "react";
import useAlert from "hooks/useAlert";
import { showMutationAlert } from "utils/helpers";
import "./index.css";
import { useUser } from "hooks/useUser";

import useFilters from "recoilStore/useFilters";
import { useCreateReportFilterset } from "mutations/Measures/useCreateReportFiltersetMutation";

import { useUpdateActiveOrganization } from "mutations/useUpdateActiveOrganization";
import HeaderNavBar from "./HeaderNavBar";

function FiltersProvider() {
    const { filtersVersion } = useFilters();
    const { mutate: mutateCreateReportFilterset } = useCreateReportFilterset();

    useEffect(() => {
        mutateCreateReportFilterset();
    }, [filtersVersion]);
}

function Header() {
    FiltersProvider();
    const alert = useAlert();

    const { data: user, isError, isLoading } = useUser();
    const { mutate } = useUpdateActiveOrganization();

    const activeOrganizationName = user?.activeOrganization?.name;

    const memberOrganizations: BriefCustomerAccount[] = user?.memberOrganizations || [];

    if (isLoading) {
        return <HeaderNavBar memberOrganizations={[]} activeOrganizationName="" />;
    }

    if (isError || !user) {
        const errors = getError("ERR-LOADING-USER", "Error loading user information.");
        showMutationAlert(errors, alert);
    }

    if (!memberOrganizations || memberOrganizations.length === 0) {
        const errors = getError("ERR-NO-CUST-ACCOUNT", "No customer account found - Please contact Audette");
        showMutationAlert(errors, alert);
    } else if (!activeOrganizationName) {
        const defaultOrganizationUid = memberOrganizations[0].customerAccountUid;

        mutate({ activeOrganizationUid: defaultOrganizationUid });
    }

    return (
        <HeaderNavBar memberOrganizations={memberOrganizations} activeOrganizationName={activeOrganizationName || ""} />
    );
}

function getError(errorCode: string, description: string) {
    return {
        response: {
            errors: [
                {
                    errorCode,
                    description,
                },
            ],
        },
    };
}

export default Header;
